import { useMemo, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { priorityInfo } from "@/lib/format";

export function CallTypeCombo({ callTypes, value, onChange, disabled, testId = "call-type-combo" }) {
  const [open, setOpen] = useState(false);
  const selected = callTypes.find((c) => c.id === value);
  const groups = useMemo(() => {
    const g = {};
    callTypes.filter((c) => c.active !== false).forEach((c) => { (g[c.discipline] = g[c.discipline] || []).push(c); });
    return g;
  }, [callTypes]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testId} disabled={disabled} className="field-input flex items-center justify-between text-left disabled:opacity-60">
          <span className={selected ? "font-medium" : "text-muted-foreground"}>{selected ? `${selected.name}` : "Select call type…"}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[320px]" align="start">
        <Command>
          <CommandInput placeholder="Search call types…" data-testid={`${testId}-search`} autoFocus />
          <CommandList className="max-h-[300px]">
            <CommandEmpty>No call type found.</CommandEmpty>
            {Object.entries(groups).map(([disc, items]) => (
              <CommandGroup key={disc} heading={disc.toUpperCase()}>
                {items.map((c) => (
                  <CommandItem key={c.id} value={`${c.name} ${c.code} ${(c.aliases || []).join(" ")}`} onSelect={() => { onChange(c.id); setOpen(false); }} data-testid={`${testId}-option-${c.code}`}>
                    <Check className={`mr-2 h-3.5 w-3.5 ${c.id === value ? "opacity-100" : "opacity-0"}`} />
                    <span className="flex-1">{c.name}</span>
                    <span className="mono text-[10px] text-muted-foreground">{priorityInfo(c.default_priority).short}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
